import { useEffect, useState } from 'react';

import { PAYMENT_BONUS, PAYMENT_GLOBAL_ACCOUNT, STATUS_OK } from 'apps/auth/constants/Constants';
import { timer } from 'apps/auth/helpers/utils';

export function useSuccessPage(props) {
    const [showSuccess, setShowSuccess] = useState(props.isShowSuccess);

    useEffect(() => {
        props.toggleNavBar(false);
        if (showSuccess) {
            timer(
                null,
                () => {
                    props.updateExtraByName('isShowSuccess', false).then(() => setShowSuccess(false));
                },
                2000,
            );
        }
    }, [props.isShowSuccess]);

    return [showSuccess, setShowSuccess];
}

export function useWelcomePage(props) {
    const [showWelcomePage, toggleWelcomePage] = useState(props.showWelcomePage);

    useEffect(() => {
        props.toggleNavBar(false);
        if (showWelcomePage) {
            timer(
                null,
                () => {
                    props.updateExtraByName('welcomePage', false).then(() => toggleWelcomePage(false));
                },
                2000,
            );
        }
    }, []);

    return [showWelcomePage, toggleWelcomePage];
}

export const useNavBarAlign = (showIcon, hasRightIcon) => {
    const [hasLeftIcon] = useState(showIcon);
    return getNavBarAlign(hasLeftIcon, hasRightIcon);
};

export const getNavBarAlign = (hasLeftIcon, hasRightIcon) => {
    if (hasLeftIcon && hasRightIcon) {
        return 'space-between';
    } else {
        return hasLeftIcon ? 'left' : 'right';
    }
};

export const getStatus = (status) => (status === STATUS_OK ? 'success' : status > STATUS_OK ? 'error' : 'wait');
export const getStatusForBill = (status) => {
    if (status === 'waiting' || status === 'created') {
        return 'wait';
    } else if (status === 'unpayed' || status === 'canceled' || status === 'expired') {
        return 'error';
    } else if (status === 'payed') {
        return 'success';
    }
};

export const getStatusForRequest = (status) => {
    let result = 'wait';
    if (status === 'waiting' || status === 'created') {
        result = 'wait';
    } else if (status === 'unpayed' || status === 'canceled' || status === 'expired') {
        result = 'error';
    } else if (status === 'payed') {
        result = 'success';
    }
    return result;
};

export const clearGarbageData = (state = {}) => {
    delete state.pageTitle;
    delete state.pageDescription;
    delete state.pageKeywords;
    delete state.mobile;
    delete state.footer;
};
export const clearGarbageAuthData = (state) => {
    delete state.authUser;
    delete state.canPayOnAccount;
    delete state.canPayOnCard;
};
export const clearGarbageDataForSend = (state) => {
    clearGarbageData(state);
    delete state.browsers;
    delete state.languages;
    delete state.lang;
    delete state.jsMessages;
    delete state.messages;
    delete state.redirectTo;
    delete state.messageBodyMessages;
    delete state.jsSettings;
    clearGarbageAuthData(state);
};

export const getSortAndFilterArray = (array, list) => {
    return Object.values(array)
        .filter(({ paymentOptionsItems }) => {
            return paymentOptionsItems.some(({ category }) => {
                const hasCategory = list.hasOwnProperty(category);
                const method = hasCategory && list[category];
                if (method && (method.method === PAYMENT_BONUS || method.method === PAYMENT_GLOBAL_ACCOUNT)) {
                    const isNotZeroBalance = Number(method.balance) > 0;
                    return hasCategory && isNotZeroBalance;
                }
                return hasCategory;
            });
        })
        .sort((a, b) => a.orderId - b.orderId);
};
